import React, { memo } from "react";
import "./LoadingModal.css";

interface LoadingModalProps {
  isOpen: boolean;
}

const LoadingModal = ({ isOpen }: LoadingModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default memo(LoadingModal);
